import { Box } from '@mui/material';
import {
  ReleaseButtonContainer,
  ReleaseMenuButton,
} from 'components/SongActionButtons/components/ReleaseButton';
import SongActionsMenu from 'components/SongActionButtons/components/SongActionsMenu';

import {
  AddToLibraryButton,
  CopyLinkButton,
  DownloadButton,
  StudioButton as StudioMenuButton,
} from 'components/SongActionButtons/components/SongActionsMenu/components';
import { AnalyticsEventLocation } from 'services/analytics/entities';
import { getSongDetailsURL } from 'services/helpers/song';
import { VegaSong } from 'services/store/ai/types';

interface MobileTrackActionButtonsProps {
  song: VegaSong;
  removeFromLibrary: () => void;
  addToLibraryHandler: () => void;
  location: AnalyticsEventLocation;
  downloadHandler: () => void;
}

const MobileTrackActionButtons = ({
  song: { id, title, songType, isInLibrary },
  removeFromLibrary,
  addToLibraryHandler,
  location,
  downloadHandler,
}: MobileTrackActionButtonsProps) => (
  <Box
    sx={{
      gridArea: 'menuButton',
      display: 'flex',
      justifyContent: 'center',
    }}
  >
    <SongActionsMenu>
      <StudioMenuButton songId={id} isAIGenerated location={location} />
      <AddToLibraryButton
        isInLibrary={isInLibrary}
        removeFromLibrary={removeFromLibrary}
        addToLibrary={addToLibraryHandler}
      />
      <CopyLinkButton copySongURL={getSongDetailsURL(id, title)} />
      <ReleaseButtonContainer songId={id} location={location}>
        <ReleaseMenuButton songId={id} />
      </ReleaseButtonContainer>
      <DownloadButton
        songId={id}
        songType={songType}
        location={location}
        addToLibrary={downloadHandler}
      />
    </SongActionsMenu>
  </Box>
);

export default MobileTrackActionButtons;
